export const MAKE_TOAST = "UI/TOASTER/MAKE_TOAST";
export const REMOVE_TOAST = "UI/TOASTER/REMOVE_TOAST";
export const REMOVE_ALL_TOAST = "UI/TOASTER/REMOVE_ALL_TOAST";
